"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const native_1 = require("@react-navigation/native");
const styles_1 = __importDefault(require("../../styles/styles"));
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const scheduleSlice_1 = require("./scheduleSlice");
const boxTitle_1 = __importDefault(require("../../components/boxTitle/boxTitle"));
const icon_1 = __importDefault(require("../../components/icon/icon"));
const scheduleComponent_1 = __importDefault(require("./scheduleComponent"));
const schedulesConstants_1 = require("./schedulesConstants");
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const callLaterComponent_1 = __importDefault(require("../../components/scheduleAction/callLaterComponent"));
const useWebDesktopDesign_1 = __importDefault(require("../../hooks/useWebDesktopDesign"));
const metricsComponent_1 = __importDefault(require("../../components/metricsComponent/metricsComponent"));
const nextButon_1 = __importDefault(require("../../components/scheduleAction/nextButon"));
const typesConstants_1 = require("../../constants/typesConstants");
const userScheduleComponent_1 = __importDefault(require("./userScheduleComponent"));
const SchedulesOverview = ({ message }) => (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterStart, styles_1.default.marginLeftTen, styles_1.default.flexOne] },
    react_1.default.createElement(react_native_paper_1.Title, { style: styles_1.default.textColorBlack }, message)));
const Schedule = () => {
    const dispatch = useAppDispatch_1.default();
    const { loadingStatus, schedule, loan, user, officerFirstName } = useAppSelector_1.default((state) => ({
        loadingStatus: state.schedule.status,
        schedule: state.schedule.schedule,
        loan: state.schedule.loan,
        user: state.schedule.user,
        officerFirstName: state.auth.user.first_name,
    }));
    const isDesktop = useWebDesktopDesign_1.default();
    // Refresh when enter screen
    native_1.useFocusEffect(react_1.useCallback(() => {
        dispatch(scheduleSlice_1.resetScheduleState());
        dispatch(scheduleSlice_1.getNextSchedule());
    }, []));
    // Make request to start schedule or get loan when screen is in focus or schedule/loan was updated.
    native_1.useFocusEffect(react_1.useCallback(() => {
        // If loan has already been paid, mark as complete and move to next schedule.
        if (loan && !loan.available_for_recovery) {
            (async () => {
                await dispatch(scheduleSlice_1.resetScheduleState());
                await dispatch(scheduleSlice_1.completeSchedule({ scheduleId: schedule.id }));
                dispatch(scheduleSlice_1.getNextSchedule());
            })();
        }
        // FLOW: GET SCHEDULES |-> IF IS NOT STARTED OR IS RESCHEDULED -> START SCHEDULE -> GET LOAN
        //                     |-> IF IS STARTED -> GET LOAN
        if (schedule &&
            (schedule.status === schedulesConstants_1.SCHEDULE_STATUS_NOT_STARTED ||
                schedule.status === schedulesConstants_1.SCHEDULE_STATUS_RESCHEDULED ||
                schedule.status === schedulesConstants_1.SCHEDULE_STATUS_RECYCLE)) {
            dispatch(scheduleSlice_1.startSchedule({ scheduleId: schedule.id }));
        }
        else if (schedule && schedule.status === schedulesConstants_1.SCHEDULE_STATUS_STARTED && !(loan || user)) {
            dispatch(scheduleSlice_1.getScheduleCustomerData({ scheduleId: schedule.id }));
        }
    }, [schedule, loan, user]));
    const pageContent = (react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexDirectionColumn },
        react_1.default.createElement(react_native_1.View, { style: isDesktop
                ? [styles_1.default.flexDirectionRow, styles_1.default.flexOne]
                : [styles_1.default.flexDirectionColumn, styles_1.default.marginBottomTen] },
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTen },
                react_1.default.createElement(boxTitle_1.default, { title: `${schedule ? schedule.partner_name : ''} Schedule` }),
                react_1.default.createElement(boxTitle_1.default, { title: schedule ? schedule.category_display : 'Credit Recovery' })),
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterEnd, styles_1.default.flexOne] },
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, isDesktop && styles_1.default.marginTopTen] },
                    react_1.default.createElement(react_native_1.View, { style: isDesktop && styles_1.default.marginRightTen },
                        react_1.default.createElement(callLaterComponent_1.default, { schedule: schedule })),
                    react_1.default.createElement(react_native_1.View, null,
                        react_1.default.createElement(nextButon_1.default, { schedule: schedule }))))),
        react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.flexDirectionRow, styles_1.default.marginTopTen] },
            react_1.default.createElement(SchedulesOverview, { message: `Hi ${officerFirstName}` })),
        react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(metricsComponent_1.default, null)),
        schedule && !!schedule.notes && (react_1.default.createElement(react_native_1.View, { style: [
                styles_1.default.flexOne,
                styles_1.default.flexDirectionRow,
                styles_1.default.boxStyles,
                styles_1.default.alignItemsCenter,
                styles_1.default.paddingTen,
                styles_1.default.marginTopTen,
            ] },
            react_1.default.createElement(icon_1.default, { icon: free_solid_svg_icons_1.faStickyNote }),
            react_1.default.createElement(react_native_paper_1.Title, { style: [styles_1.default.textColorBlack, styles_1.default.marginLeftTen] }, schedule.notes)))));
    return schedule && schedule.external_id_type === typesConstants_1.EXTERNAL_ID_TYPE_USER ? (react_1.default.createElement(userScheduleComponent_1.default, { loadingStatus: loadingStatus, schedule: schedule, user: user, pageContent: pageContent, displayActions: true })) : (react_1.default.createElement(scheduleComponent_1.default, { schedule: schedule, loan: loan, loadingStatus: loadingStatus, pageContent: pageContent }));
};
exports.default = Schedule;
